import * as React from "react";
const SvgRectangleHorizontalThin = (props) => /* @__PURE__ */ React.createElement("svg", { focusable: "false", viewBox: "0 7 24 8", className: "svg-icon", style: {
  height: 8
}, "aria-hidden": "true", ...props }, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M22 9v6H2V9h20zm-2 2H4v2h16v-2z" }));
export default SvgRectangleHorizontalThin;
